export default __webpack_public_path__ + "static/media/all-exports.4b68bd57.png";